import script from "./MCF_PR_001.vue?vue&type=script&setup=true&lang=js"
export * from "./MCF_PR_001.vue?vue&type=script&setup=true&lang=js"

import "./MCF_PR_001.vue?vue&type=style&index=0&id=6589dea2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6589dea2"]])

export default __exports__